import Visible from "../components/Svg/Visible"
import NotVisible from "../components/Svg/NotVisible" 
import Button from "./Button"
import useForm from "../useForm"
import usePassword from "../usePassword"

function GeneralSettings() {
  const {handleChange, values, handleSubmit, errors, message, errmsg} = useForm({
    old_password: '',
    new_password: '',
    confirm_new_password: ''
  });
  const {showPassword, handleShowPassword, showConfirmPassword, handleHidePassword, showOldPassword, handleShowConfirmPassword, handleHideConfirmPassword, handleHideOldPassword, handleShowOldPassword} = usePassword();
  return (
   <div className="gs-container">
     <h6 className="gs-header">Change Password</h6>
     {message ? <p className="text-success my-3 message">{message}</p> : <p className="text-danger my-3 message">{errmsg}</p>}
     <form onSubmit={handleSubmit}>
     <div className="gs-input-group">
       <label htmlFor="old-password">Current Password</label>
              <div className="gs-input-subgroup">
              <input 
              className={errors.old_password ? "error gs-input" : "gs-input"} 
              type={showOldPassword ? "text" : "password"}
              id="old-password"
              name="old_password"
              value={values.old_password}
              onChange={handleChange} />
                {showOldPassword ?
                <div className="gs-not-visible-group" onClick={handleHideOldPassword}>
                <NotVisible stroke="#7A8996" />
              </div> : 
              <div className="gs-visible-group" onClick={handleShowOldPassword}>
              <Visible fill="#7A8996" />
            </div>}
            {errors.old_password && <p className="small">{errors.old_password}</p>}
              </div>
          </div>
          
     <div className="gs-input-group">
       <label htmlFor="new-password">New Password</label>
       <div className="gs-input-subgroup">
       <input 
              className={errors.new_password ? "error gs-input" : "gs-input"} 
              type={showPassword ? "text" : "password"}
              id="new-password"
              name="new_password"
              value={values.new_password}
              onChange={handleChange} />
                {showPassword ?
                <div className="gs-not-visible-group" onClick={handleHidePassword}>
                <NotVisible stroke="#7A8996"/>
              </div> : 
              <div className="gs-visible-group" onClick={handleShowPassword}>
              <Visible fill="#7A8996" />
            </div>}
            {errors.new_password && <p className="small">{errors.new_password}</p>}
       </div>
          </div>
          
     <div className="gs-input-group">
       <label htmlFor="confirm-new-password"> Confirm New Password</label>
        <div className="gs-input-subgroup">
        <input 
              className={errors.confirm_new_password ? "error gs-input" : "gs-input"} 
              type={showConfirmPassword ? "text" : "password"}
              id="confirm-new-password"
              name="confirm_new_password"
              value={values.confirm_new_password}
              onChange={handleChange} />
                {showConfirmPassword ?
                <div className="gs-not-visible-group" onClick={handleHideConfirmPassword}>
                <NotVisible stroke="#7A8996"/>
              </div> : 
              <div className="gs-visible-group" onClick={handleShowConfirmPassword}>
              <Visible fill="#7A8996"/>
            </div>}
            {errors.confirm_new_password && <p className="small">{errors.confirm_new_password}</p>}
        </div>
          </div>
         <div className="gs-btn-group">
         <Button disabled={errors.confirm_new_password} type="submit">
            Save Changes
          </Button>
         </div>
     </form>
   </div>
  )
}

export default GeneralSettings